export default "__VITE_ASSET__Y6gfx9wr__"